import React from 'react';
import PropTypes from 'prop-types';

function Case({ children }) {
  return children;
}

Case.propTypes = {
  children: PropTypes.node,
};

Case.defaultProps = {
  children: null,
};

export default Case;
